﻿import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import { dashboard_pages } from '@Util/GlobalValues';
import { Icon_Arrow_Right, Icon_Arrow_Down } from '@Elements/ImageElements/Icons';
import Featured_Projects_List from '@Elements/DynamicIsland/Featured_Projects_List';

const Featured_Projects: React.FC = React.memo(() => {
    const [t] = useTranslation();
    const featured_projects_menu_ref = useRef<HTMLDivElement | null>(null);
    const [menu_is_active, set_menu_is_active] = useState<boolean>(false);

    const handleClickOutside = useCallback((e: MouseEvent) => {
        if (featured_projects_menu_ref.current && !featured_projects_menu_ref.current.contains(e.target as Node) && menu_is_active) {
            set_menu_is_active(false);
        }
    }, [menu_is_active]);

    useEffect(() => {
        if (menu_is_active) {
            document.addEventListener('click', handleClickOutside);
        } else {
            document.removeEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [menu_is_active, handleClickOutside]);

    const toggleMenu = useCallback(() => {
        set_menu_is_active(prev => !prev);
    }, []);

    const closeMenu = useCallback(() => {
        set_menu_is_active(false);
    }, []);

    return (
        <div className="Dynamic_Island_Featured_Projects">
            <button
                type="button"
                className="Dynamic_Island_Featured_Projects_Toggle"
                title={menu_is_active ? t('Hover.CloseFeaturedProjects') : t('Hover.OpenFeaturedProjects')}
                onClick={toggleMenu}
            >
                <Icon_Arrow_Down />
            </button>
            {menu_is_active && (
                <nav ref={featured_projects_menu_ref} className="Dynamic_Island_Featured_Projects_List_Wrapper">
                    <NavLink
                        to={dashboard_pages.projects}
                        end
                        className="Dynamic_Island_Featured_Projects_List_PageLink"
                        title={t('Navigation.Projects')}
                        onClick={closeMenu}
                    >
                        {t('Button.TrackTimeOn')}
                        <Icon_Arrow_Right />
                    </NavLink>
                    <Featured_Projects_List set_menu_is_active={set_menu_is_active} />
                </nav>
            )}
        </div>
    );
});

export default Featured_Projects;